import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StateService } from '../services/state.service';

@Injectable({
  providedIn: 'root'
})
export class UserAuthorizedGuard  {

  constructor(
    private router: Router,
    private stateService: StateService,
    private snackBar: MatSnackBar,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const currentUser = this.stateService.getCurrentUser();

      if (currentUser.authorized) {
          // logged in so return true
          return true;
      }
      // Session is valid but the account isn't provisioned yet — soft bounce to
      // /login. Do NOT call purgeAuth()/posthog.reset() here: the cookie stays
      // live, and reset() would break in-app PostHog Conversations with no reload
      // to recover (SPA nav). Just clear the in-memory user and navigate.
      this.snackBar.open("Tu cuenta aún se está configurando. Recibirás un email cuando puedas acceder.","OK", {duration:5000})
      this.stateService.setCurrentUser(null);
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

}
